const UpgradeRequestStatuses = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  PAID: 'paid',
  OLD: 'old',
};

module.exports = UpgradeRequestStatuses;
